import { FormlyFieldConfig } from '@ngx-formly/core';

import { agreementRolesOptions } from '../../agreements/roles';

const CommentsNotesForm: FormlyFieldConfig = {
  wrappers: [],
  fieldGroupClassName: 'layout-padding',
  props: {
    label: 'Internal comments',
  },
  fieldGroup: [
    {
      key: 'comments',
      type: 'wysiwyg',
      defaultValue: null,
      className: 'ant-col ant-col-24',
      props: {
        label: 'Comments / Notes',
        rows: 5,
        required: false,
      },
    },
  ],
};

export const AdditionnalDisplayedInformation: FormlyFieldConfig = {
  wrappers: [],
  fieldGroupClassName: 'layout-padding',
  props: {
    label: 'Additional displayed information',
  },
  fieldGroup: [
    {
      key: 'additionalInformations',
      type: 'wysiwyg',
      defaultValue: null,
      className: 'ant-col ant-col-24',
      props: {
        label: 'Additional displayed information',
        rows: 5,
        required: false,
      },
    },
  ],
};

const AttachedFilesForm: FormlyFieldConfig = {
  wrappers: [],
  fieldGroupClassName: 'layout-padding',
  props: {
    label: 'Attached files',
  },
  fieldGroup: [
    {
      key: 'files',
      type: 'file',
      defaultValue: [],
      className: 'ant-col ant-col-24',
      props: {
        label: 'Attached files',
        required: false,
        multiple: true,
      },
    },
  ],
};

export const CommentsNotesFormAndAttachedFilesForm: FormlyFieldConfig[] = [
  CommentsNotesForm,
  AttachedFilesForm,
];

const getOpportunisticForm = (label: string) => {
  return {
    key: 'isOpportunistic',
    type: 'checkbox',
    className: 'ant-col ant-col-fourth checkbox-layout',
    defaultValue: false,
    props: {
      label,
      required: false,
    },
  };
};

export const opportunisticBuyerForm = {
  ...getOpportunisticForm('Opportunistic Buyer'),
};

export const opportunisticSellerForm = {
  ...getOpportunisticForm('Opportunistic Seller'),
};

export const getTermViewerFormField = (
  key: string,
  label: string
): FormlyFieldConfig => {
  return {
    key,
    type: 'select',
    defaultValue: [],
    props: {
      multiple: true,
      label,
      options: agreementRolesOptions,
    },
  };
};

export const getFormField = (
  formField: FormlyFieldConfig,
  propsConfig: any = null
): FormlyFieldConfig => {
  if (propsConfig) {
    return {
      ...formField,
      props: {
        ...formField.props,
        ...propsConfig,
      },
    };
  }

  return formField;
};
